"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var redux_1 = require("redux");
var onTheSpotDux = tslib_1.__importStar(require("./dux/ots"));
var fetch_1 = tslib_1.__importStar(require("./dux/fetch"));
var progress_1 = tslib_1.__importStar(require("./dux/progress"));
var programs_1 = tslib_1.__importStar(require("./dux/programs"));
var client_1 = tslib_1.__importStar(require("./dux/client"));
var translations_1 = tslib_1.__importStar(require("./dux/translations"));
exports.default = (function (customReducers) {
    var _a;
    return redux_1.combineReducers(tslib_1.__assign({}, customReducers, (_a = {}, _a[translations_1.ROOT_KEY] = translations_1.default, _a[progress_1.ROOT_KEY] = progress_1.default, _a[programs_1.ROOT_KEY] = programs_1.default, _a[fetch_1.ROOT_KEY] = fetch_1.default, _a[client_1.ROOT_KEY] = client_1.default, _a.onTheSpot = onTheSpotDux.onTheSpotReducer, _a)));
});
//# sourceMappingURL=reducers.js.map